import Vue from 'vue';
import inViewportDirective from 'vue-in-viewport-directive';

Vue.directive('in-viewport', inViewportDirective);
